import $ from "jquery";
import debug from "debug";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-header-controller]";
const PLUGIN_NAME = "headerController";

const log = debug("site-header/header-controller:header");

class HeaderController {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.isSearchCollapsible = !!this.options.searchComponentSelector;

		this.searchComponent =
			this.isSearchCollapsible &&
			this.selectors.selectTarget(
				this.options.searchComponentSelector,
				this.$element
			);

		this.watch();

		log("ready", this, this.$target);
	}

	watch() {
		log("watching");

		var self = this;

		this.element.addEventListener(
			"navigation_toggled",
			this.handleNavigationToggle.bind(this)
		);

		this.element.addEventListener(
			"contents_menu_opened",
			this.handleContentsOpened.bind(this)
		);

		this.$element.find("[data-collapsible]").on(
			"collapsible_opened",
			self.handleContentsOpened.bind(self)
		);

		document.addEventListener("click", (event) => {

			let collapsibleElement = this.$element.find("[data-collapsible]")[0];
			if (!collapsibleElement) {
				return false;
			}

			const isClickedOutside = !collapsibleElement.contains(event.target);

			if (isClickedOutside) {
			  // Hide the target element
			  collapsibleElement.setAttribute('data-collapsible-open', 'false');
			}
		  });

	}

	handleNavigationToggle() {
		this.tryConcealSearch();
		this.tryConcealCollapsible();
	}

	tryConcealSearch() {
		log("attempting to disable search");
		if (this.isSearchCollapsible) {
			this.searchComponent.trigger("disablesearch");
			this.element.classList.remove("site-header--global-search-is-open");
		} else {
			log("Search is not collapsible");
		}
	}

	tryConcealCollapsible(){
		Array.from(this.element.querySelectorAll("[data-collapsible]")).forEach(item => {
			item.setAttribute('data-collapsible-open', 'false');
		});
	}

	closeMegaMenus() {
		Array.from(
			document.querySelectorAll(`.${this.options.navigationActiveClass}`)
		).forEach((activeItem) => {
			activeItem.classList.remove(this.options.navigationActiveClass);
		});
	}

	handleContentsOpened() {
		this.tryConcealSearch();
		this.closeMegaMenus();
	}
}

HeaderController.DEFAULTS = {
	navigationActiveClass: "navigation__item--is-active",
};

plugin(PLUGIN_NAME, HeaderController);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/site__ale001/components/site-header/header/header-controller.js